import React, { useRef, useState, useEffect } from "react";
import Sidebar from "../../components/Structure/Sidebar";
import HoldOn from 'react-hold-on';
import { useDispatch, useSelector } from "react-redux";
import { getRemitterListByStudentId } from "../../@redux/Action/Remitter";
import { FaPlus, FaSearch, FaChevronLeft, FaChevronRight, FaTimes } from 'react-icons/fa';
import { MenuItem, TextField, Button, Modal as MuiModal, Box } from "@mui/material";
import { Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { CustomTextField } from "../../utils/Fields";
import RemitterType from '../../components/RemitterType';

function RemitterPage({studentId}) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [remitterData, setRemitterData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState("");
    const [showAddRemitterModal, setShowAddRemitterModal] = useState(false);
    const [openDetailsModal, setOpenDetailsModal] = useState(false);
    const [selectedRemitter, setSelectedRemitter] = useState(null);
    const [currentStep, setCurrentStep] = useState(1);
    const remittersPerPage = 10;

    const fetchRemitterData = async () => {
        try {
            const data = await dispatch(getRemitterListByStudentId(studentId));
            if (Array.isArray(data)) {
                setRemitterData(data);
            } else if (data && typeof data === 'object') {
                setRemitterData([data]);
            } else {
                setRemitterData([]);
            }
        } catch (error) {
            console.error("Error fetching remitter data:", error);
            setRemitterData([]);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchRemitterData();
    }, [dispatch, studentId]);

    const handleSearch = (value) => {
        setSearchTerm(value);
    };

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '80%',
        maxWidth: 800,
        bgcolor: 'background.paper',
        boxShadow: 24,
        maxHeight: '90vh',
        overflow: 'auto',
        borderRadius: '12px',
        border: 'none'
    };

    const handleDetailsModalOpen = (remitter) => {
        setSelectedRemitter(remitter);
        setOpenDetailsModal(true);
    };

    const handleDetailsModalClose = () => {
        setSelectedRemitter(null);
        setOpenDetailsModal(false);
    };
    console.log("selectedRemitter",selectedRemitter);

    const handleAddRemitter = () => {
        setShowAddRemitterModal(true);
    };

    const handleCloseAddRemitterModal = () => {
        setShowAddRemitterModal(false);
        setCurrentStep(1);
    };

    const handleRemitterSubmit = async () => {
        handleCloseAddRemitterModal();
        await fetchRemitterData();
    };

    // Filter remitters based on search term
    const filteredRemitters = remitterData.filter(remitter => {
        if (remitter && typeof remitter === 'object') {
            const firstName = remitter.first_name || '';
            const lastName = remitter.last_name || '';
            const fullName = `${firstName} ${lastName}`.toLowerCase();
            return fullName.includes(searchTerm.toLowerCase());
        }
        return false;
    });

    // Get current remitters
    const indexOfLastRemitter = currentPage * remittersPerPage;
    const indexOfFirstRemitter = indexOfLastRemitter - remittersPerPage;
    const currentRemitters = Array.isArray(filteredRemitters) ? filteredRemitters.slice(indexOfFirstRemitter, indexOfLastRemitter) : [];

    // Change page
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    // Calculate total pages based on filtered results
    const totalPages = Array.isArray(filteredRemitters) ? Math.ceil(filteredRemitters.length / remittersPerPage) : 0;

    return (
        <div className="d-md-flex" style={{ height: "100vh", backgroundColor: "#f8f9fa" }}>
            {/* left section */}
            <Sidebar />

            {/* right section */}
            <div className="col-12 col-md-9 px-4 rounded-4 d-flex flex-column overflow-hidden">
                <div className="my-4 mx-auto w-100 d-flex flex-column h-100">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <h2 className="mb-0 text-success">Remitters</h2>
                        <button className="btn btn-success d-flex align-items-center" onClick={handleAddRemitter}>
                            <FaPlus className="me-2" /> Add Remitter
                        </button>
                    </div>
                    <MuiModal
                        open={openDetailsModal}
                        onClose={handleDetailsModalClose}
                        aria-labelledby="details-modal-title"
                        aria-describedby="details-modal-description"
                    >
                        <Box sx={modalStyle} className="p-0">
                            <div className="modal-header bg-success text-white p-4 position-relative">
                                <h4 className="mb-0">Remitter Details</h4>
                                <FaTimes 
                                    className="position-absolute" 
                                    style={{top: '20px', right: '20px', cursor: 'pointer'}}
                                    onClick={handleDetailsModalClose}
                                />
                            </div>

                            {selectedRemitter && (
                                <>
                                    <div className="modal-body p-4">
                                        <div className="my-auto">
                                            <div className="roboto-medium d-flex flex-column h-100">
                                                <div className="flex-grow-1 d-flex flex-column">
                                                    <div className="d-flex flex-column justify-content-between">
                                                        <div className="d-flex justify-content-between gap-3 mb-3">
                                                            <div className="form-group w-50">
                                                                <CustomTextField
                                                                    label="First Name"
                                                                    value={selectedRemitter.first_name || ''}
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    InputProps={{
                                                                        readOnly: true,
                                                                        style: { backgroundColor: '#fff' }
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="form-group w-50">
                                                                <CustomTextField
                                                                    label="Last Name"
                                                                    value={selectedRemitter.last_name || ''}
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    InputProps={{
                                                                        readOnly: true,
                                                                        style: { backgroundColor: '#fff' }
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="d-flex justify-content-between gap-3 mb-3">
                                                            <div className="form-group w-50">
                                                                <CustomTextField
                                                                    label="Phone"
                                                                    value={`${selectedRemitter.isd_code || ''}${selectedRemitter.phone || ''}`}
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    InputProps={{
                                                                        readOnly: true,
                                                                        style: { backgroundColor: '#fff' }
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="form-group w-50">
                                                                <CustomTextField
                                                                    label="Date of Birth"
                                                                    value={selectedRemitter.dob ? new Date(selectedRemitter.dob).toLocaleDateString('en-US', {
                                                                        month: '2-digit',
                                                                        day: '2-digit',
                                                                        year: 'numeric'
                                                                    }).replace(/\//g, '-') : ''}
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    InputProps={{
                                                                        readOnly: true,
                                                                        style: { backgroundColor: '#fff' }
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="d-flex justify-content-between gap-3 mb-3">
                                                            <div className="form-group w-50">
                                                                <CustomTextField
                                                                    label="Aadhar Number"
                                                                    value={selectedRemitter.aadhar_number || ''}
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    InputProps={{
                                                                        readOnly: true,
                                                                        style: { backgroundColor: '#fff' }
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="form-group w-50">
                                                                <CustomTextField
                                                                    label="PAN Number"
                                                                    value={selectedRemitter.pan_number || ''}
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    InputProps={{
                                                                        readOnly: true,
                                                                        style: { backgroundColor: '#fff' }
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="d-flex justify-content-between gap-3 mb-3">
                                                            <div className="form-group w-50">
                                                                <CustomTextField
                                                                    label="Passport Number"
                                                                    value={selectedRemitter.passport_number || ''}
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    InputProps={{
                                                                        readOnly: true,
                                                                        style: { backgroundColor: '#fff' }
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="form-group w-50">
                                                                <CustomTextField
                                                                    label="Remitter ID"
                                                                    value={selectedRemitter.remitter_id || ''}
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    InputProps={{
                                                                        readOnly: true,
                                                                        style: { backgroundColor: '#fff' }
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="d-flex justify-content-between gap-3 mb-3">
                                                            <div className="form-group w-50">
                                                                <CustomTextField
                                                                    label="City"
                                                                    value={selectedRemitter.city || ''}
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    InputProps={{
                                                                        readOnly: true,
                                                                        style: { backgroundColor: '#fff' }
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="form-group w-50">
                                                                <CustomTextField
                                                                    label="State"
                                                                    value={selectedRemitter.state || ''}
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    InputProps={{
                                                                        readOnly: true,
                                                                        style: { backgroundColor: '#fff' }
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="d-flex justify-content-between gap-3 mb-3">
                                                            <div className="form-group w-50">
                                                                <CustomTextField
                                                                    label="Country"
                                                                    value={selectedRemitter.country || ''}
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    InputProps={{
                                                                        readOnly: true,
                                                                        style: { backgroundColor: '#fff' }
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="form-group w-50">
                                                                <CustomTextField
                                                                    label="Pincode"
                                                                    value={selectedRemitter.pincode || ''}
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    InputProps={{
                                                                        readOnly: true,
                                                                        style: { backgroundColor: '#fff' }
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="d-flex justify-content-between gap-3 mb-3">
                                                            <div className="form-group w-50">
                                                                <CustomTextField
                                                                    label="Street Address"
                                                                    value={selectedRemitter.street_address || ''}
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    InputProps={{
                                                                        readOnly: true,
                                                                        style: { backgroundColor: '#fff' }
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="form-group w-50">
                                                                <CustomTextField
                                                                    label="Status"
                                                                    value={selectedRemitter.status || ''}
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    InputProps={{
                                                                        readOnly: true,
                                                                        style: { backgroundColor: '#fff' }
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="d-flex justify-content-between gap-3 mb-3">
                                                            <div className="form-group w-50">
                                                                <CustomTextField
                                                                    label="Relation Type"
                                                                    value={selectedRemitter.relation_type || 'Not Specified'}
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    InputProps={{
                                                                        readOnly: true,
                                                                        style: { backgroundColor: '#fff' }
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="form-group w-50">
                                                                <CustomTextField
                                                                    label="Source of Fund"
                                                                    value={selectedRemitter.source_of_fund || 'Not Specified'}
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    InputProps={{
                                                                        readOnly: true,
                                                                        style: { backgroundColor: '#fff' }
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                        </Box>
                    </MuiModal>
                    <div className="mb-3 position-relative">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Search remitters by name..."
                            value={searchTerm}
                            onChange={(e) => handleSearch(e.target.value)}
                        />
                        <FaSearch className="position-absolute top-50 end-0 translate-middle-y me-3 text-muted" />
                    </div>
                    {isLoading ? (
                        <div className="d-flex justify-content-center align-items-center h-100">
                            <div className="spinner-border text-success" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : filteredRemitters.length > 0 ? (
                        <div className="table-responsive flex-grow-1 bg-white rounded shadow-sm" style={{ fontSize: '0.9rem' }}>
                            <table className="table table-hover mb-0">
                                <thead className="bg-light">
                                    <tr>
                                        <th className="text-success fw-bold py-3 px-3">Name</th>
                                        <th className="text-success fw-bold py-3 px-3">Phone</th>
                                        <th className="text-success fw-bold py-3 px-3">City</th>
                                        <th className="text-success fw-bold py-3 px-3">State</th>
                                        <th className="text-success fw-bold py-3 px-3">Country</th>
                                        <th className="text-success fw-bold py-3 px-3">Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentRemitters.map((remitter, index) => (
                                        <tr key={index} 
                                            className="align-middle cursor-pointer" 
                                            onClick={() => handleDetailsModalOpen(remitter)}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <td className="py-2 px-3">{`${remitter.first_name || ''} ${remitter.last_name || ''}`}</td>
                                            <td className="py-2 px-3">{`${remitter.isd_code || ''}${remitter.phone || ''}`}</td>
                                            <td className="py-2 px-3">{remitter.city || ''}</td>
                                            <td className="py-2 px-3">{remitter.state || ''}</td>
                                            <td className="py-2 px-3">{remitter.country || ''}</td>
                                            <td className="py-2 px-3">
                                                <span
                                                    className={`badge ${
                                                        remitter.status === "Approved"
                                                            ? "bg-success"
                                                            : "bg-warning"
                                                    }`}
                                                >
                                                    {remitter.status || ''}
                                                </span>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <div className="alert alert-info" role="alert">
                            No Remitter data available.
                        </div>
                    )}
                    <nav className="mt-4">
                        <ul className="pagination justify-content-center">
                            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                <button className="page-link text-success" onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
                                    <FaChevronLeft />
                                </button>
                            </li>
                            {totalPages <= 5 ? (
                                [...Array(totalPages)].map((_, i) => (
                                    <li key={i} className={`page-item ${currentPage === i + 1 ? 'active' : ''}`}>
                                        <button className={`page-link ${currentPage === i + 1 ? 'bg-success text-white' : 'text-success'}`} onClick={() => paginate(i + 1)}>{i + 1}</button>
                                    </li>
                                ))
                            ) : (
                                <>
                                    {currentPage > 2 && (
                                        <>
                                            <li className="page-item"><button className="page-link text-success" onClick={() => paginate(1)}>1</button></li>
                                            {currentPage > 3 && <li className="page-item disabled"><span className="page-link text-success">...</span></li>}
                                        </>
                                    )}
                                    {[...Array(5)].map((_, i) => {
                                        const pageNum = currentPage + i - 2;
                                        return pageNum > 0 && pageNum <= totalPages ? (
                                            <li key={i} className={`page-item ${currentPage === pageNum ? 'active' : ''}`}>
                                                <button className={`page-link ${currentPage === pageNum ? 'bg-success text-white' : 'text-success'}`} onClick={() => paginate(pageNum)}>{pageNum}</button>
                                            </li>
                                        ) : null;
                                    })}
                                    {currentPage < totalPages - 1 && (
                                        <>
                                            {currentPage < totalPages - 2 && <li className="page-item disabled"><span className="page-link text-success">...</span></li>}
                                            <li className="page-item"><button className="page-link text-success" onClick={() => paginate(totalPages)}>{totalPages}</button></li>
                                        </>
                                    )}
                                </>
                            )}
                            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                <button className="page-link text-success" onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages}>
                                    <FaChevronRight />
                                </button>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>

            {/* Add Remitter Modal */}
            <Modal show={showAddRemitterModal} onHide={handleCloseAddRemitterModal} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title className="text-success">Add New Remitter</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <RemitterType setCurrentStep={setCurrentStep} studentId={studentId} onSubmitSuccess={handleRemitterSubmit} />
                </Modal.Body>
            </Modal>
        </div>
    );
}

export default RemitterPage;